export default class StringUtils {

  static initials(name: string, length: number = 2): string {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= length) { return parts.slice(0, length).map(part => part[0]).join("").toUpperCase(); }
    return name.trim().substring(0, length).toUpperCase();
  }

}